import { html } from '../lib/html.js';

/** Pedaços de tela da vitrine, usados no Início, na lista e no perfil da oficina. */

/** Selo "Verificada" (visita presencial do TicketCar). */
export const verifiedTag = () => html`<span class="ver-tag"><ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>Verificada</span>`;
